// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"c6ceab54","905":"eed1462e"}[chunkId] + ".chunk.js";
};